import React from "react";
import ErrorPage from "./ErrorPage";

export default function Error403(props) {
  return <ErrorPage code={403} {...props} />;
}
